import React from 'react';
import { View, FlatList } from 'react-native';

import OPComponent from '../../op_component';

import { COLOR, FONT, FONT_SIZE, THEME } from '../../../../constants/styles';

import RemoveButton from './remove_button';
import ListItem from './list_item';

import Swipeable from '../../swipable';

const LIST_ITEM_HEIGHT = 110;

export default class List extends OPComponent {
  constructor(props) {
    super(props);
  }

  rightButtons = ({ item }) => {
    return [<RemoveButton width={LIST_ITEM_HEIGHT} item={item} onPress={this.props.onRemove} />];
  };

  renderItemScrollable = ({ item }) => {
    return this.renderItem(item);
  };

  renderItem = (item) => {
    if (this.props.swipeDisabled) {
      return (
        <ListItem
          key={this.keyExtractor(item)}
          height={LIST_ITEM_HEIGHT}
          item={item}
          onPress={this.props.onSelect}
        />
      );
    }

    return (
      <Swipeable
        key={this.keyExtractor(item)}
        rightButtons={this.rightButtons(item)}
        rightButtonWidth={LIST_ITEM_HEIGHT}
      >
        <ListItem height={LIST_ITEM_HEIGHT} item={item} onPress={this.props.onSelect} />
      </Swipeable>
    );
  };

  keyExtractor = ({ item }) => {
    return this.props.keyExtractor(item);
  };

  render() {
    if (this.props.scrollable) {
      return (
        <View style={THEME.container}>
          <FlatList
            data={this.props.data}
            renderItem={this.renderItemScrollable}
            keyExtractor={this.keyExtractor}
          />
        </View>
      );
    } else {
      return <View style={THEME.container}>{this.props.data.map(this.renderItem)}</View>;
    }
  }
}
